import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import AsyncSelect from 'react-select/async';
import { mergeSelectStyles } from '../../../shared/darkSelectStyles';

const axios = require('axios').default;

const selectStyles = mergeSelectStyles({
  control: (base, state) => (state.isFocused ? { ...base, borderColor: 'var(--sl-border-brand)' } : base)
});

// Maps the field's stored association_type to its team-scoped autocomplete endpoint.
const endpointFor = (associationType, teamId) => {
  if (associationType === 'Confirm') {
    return { url: `/teams/${teamId}/calendar_events/autocomplete`, params: { confirm_only: true, only_future: false } };
  }
  return { url: `/teams/${teamId}/crm/fans/autocomplete`, params: {} };
};

const AssociationCustomFieldValue = ({ team, customFieldValue, customFieldValueChanged }) => {
  const associationType = customFieldValue.custom_field.association_type;
  const teamId = team && team.id;

  const loadOptions = useMemo(() => _.debounce((inputValue, callback) => {
    const { url, params } = endpointFor(associationType, teamId);
    axios.get(url, { params: { ...params, name: inputValue } })
      .then((response) => {
        callback((response.data || []).map((r) => ({ value: String(r.id), label: r.title_email_preview ? `${r.name} (${r.title_email_preview})` : r.name })));
      })
      .catch(() => callback([]));
  }, 250), [associationType, teamId]);

  // allow_multiple fields hold an array of {value, label} options; single-value
  // fields keep the id-string + association_label shape.
  const isMulti = !!customFieldValue.custom_field.allow_multiple;

  const selectedOption = isMulti
    ? (Array.isArray(customFieldValue.value) ? customFieldValue.value : [])
    : (customFieldValue.value
      ? { value: String(customFieldValue.value), label: customFieldValue.association_label || customFieldValue.value }
      : null);

  return (
    <div className="row mt-3" style={{ "padding": "10px 0 15px 0" }}>
      <div className="col-12">
        <p style={{ "fontSize": "16px", "marginBottom": "12px" }}>
          <strong>{customFieldValue.custom_field.name}</strong>{!customFieldValue.custom_field.required ? " (optional)" : null}
        </p>
        <AsyncSelect
          isClearable
          isMulti={isMulti}
          cacheOptions
          defaultOptions
          menuPortalTarget={document.querySelector('body')}
          styles={selectStyles}
          value={selectedOption}
          placeholder={`Search ${associationType === 'Confirm' ? 'events' : 'contacts'}...`}
          loadOptions={loadOptions}
          onChange={(selection) => {
            if (isMulti) {
              customFieldValueChanged({ ...customFieldValue, value: selection || [] });
            } else {
              customFieldValueChanged({
                ...customFieldValue,
                value: selection ? selection.value : "",
                association_label: selection ? selection.label : null
              });
            }
          }}
        />
      </div>
    </div>
  );
};

AssociationCustomFieldValue.propTypes = {
  team: PropTypes.object,
  customFieldValue: PropTypes.object.isRequired,
  customFieldValueChanged: PropTypes.func.isRequired
};

export default AssociationCustomFieldValue;
